import React, { useState, useEffect, useCallback } from 'react';
import { getData, updateData } from '../../services/seoXmlSitemapServices';
import { Button, Form } from 'react-bootstrap';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';

const Seoxmlsitemap = () => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});  
  console.log('errors',errors);
  const [formData, setFormData] = useState({
    id: null,
    uploadedfile: null,
  });

  // get sub_domain from local storage
   const cms_sub_domain = localStorage.getItem('cms_sub_domain');

  // Fetch data from API
  const fetchData = useCallback(async () => {
    setLoading(true);
    try{
    const response = await getData();
    if (response.length > 0) {
      setFormData(response[0]); // Load first record into the form
    }
  }
  catch (error) { 
      console.error('Error fetching data:', error);
    }
  finally {
    setTimeout(() => {
    setLoading(false);
    }, 500);
  }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);


   // Validate form data
  const validateForm = () => {
  const newErrors = {};
  if (!formData.uploadedfile && formData.uploadedfile === null) {
      if (!errors.uploadedfile) newErrors.uploadedfile = "Upload XML File is required";
  }
  setErrors((prev) => ({ ...prev, ...newErrors }));
  return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);
}

  // Handle input changes
  const handleChange = async(e) => {
    try{
        const { name, value, files } = e.target;
        const file = files?.[0]
          // Create a copy of the current form data
          let updatedData = { ...formData };
          let updatedErrors = { ...errors };
          if (file) {
            const fileName = file.name.toLowerCase();
            const fileExtension = fileName.split('.').pop();

            // Check for .xml extension
            if (fileExtension !== "xml") {
              updatedErrors[name] = "Only .xml files are allowed!";
            } 
            else {
              // Valid file
              updatedData[name] = file;
              updatedErrors[name] = '';
            }
          } else {
            // If no file is selected, update based on input value
            updatedData[name] = value;
            if (value) {
              updatedErrors[name] = ''; // Clear error if value is present
            }
          }
        setFormData(updatedData);
        setErrors(updatedErrors);
      }
      catch (error) {
      console.error("Error in handleChange:", error);
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
        return
      }
    try{
    const form = new FormData();
    form.append('id', formData.id);
    form.append('uploadedfile', formData.uploadedfile);

    const result = await updateData(form);
    if (result.status === 200) {
      fetchData(); // Refresh data after update
      toast.success("Updated Successfully!", {position: 'top-right', autoClose: 3000,});
    } else {
      toast.error(result.message ||"Failed to update data. Please try again.", {position: 'top-right',autoClose: 3000});
    }
  }
   catch (error) {
      console.error("Error in handleChange:", error);
    }
  };

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
         {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className='mb-3 fs-4'>SEO Config <b>/ XML Sitemap</b></p>
              {/* <h2 className='mb-3'>Schema Markup</h2> */}
            </div>
            <div className="col-4 text-end">
              {/* <button className="btn btn-primary mb-3 form-label-custom" onClick={() => openModal('add')}>
                Add
              </button> */}
            </div>
          </div>

          {/* Editable Form (Always Visible) */}
          <div className="card p-3 mb-4">
            <Form onSubmit={handleSubmit}>
                <div className="row">
              <Form.Group className="col-md-4  col-sm-3 mb-3">
                <Form.Label className='form-label-custom'>Upload XML File <small className='text-danger'>*</small></Form.Label>
                <Form.Control type="file" name="uploadedfile"  accept=".xml"  onChange={handleChange} isInvalid = {!!errors.uploadedfile} />
                <Form.Control.Feedback type="invalid">{errors.uploadedfile}</Form.Control.Feedback>               
                {formData.uploadedfile && typeof formData.uploadedfile === 'string' && (
                  <p>
                    <a href={formData.uploadedfile} target="_blank" rel="noopener noreferrer">
                      View Current File
                    </a>
                  </p>
                )}

              </Form.Group>

              <Form.Group className="col-md-4 col-sm-4">
                    <Form.Label className='form-label-custom'>Instructions</Form.Label><br></br>
                    <small className='text-info'>1. File name should be 'sitemap.xml'</small><br></br>
                    <small className='text-info'>2. Upload '.xml' file format only</small>
              </Form.Group>
              <Form.Group className=" col-md-4 col-sm-4">
                  <Form.Label className='form-label-custom'>Check XML Sitemap &nbsp;</Form.Label>
                  {formData.xml_file ? (
                    <div>
                    <a
                    className="btn btn-warning text-dark"
                    href={
                      cms_sub_domain
                        ? `https://${cms_sub_domain}.scientexconference.com/${formData.xml_file}`
                        : (window.location.hostname === "localhost"
                            ? `http://localhost:3022/${formData.xml_file}`
                            : "/sitemap.xml")
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                      <i className="mdi mdi-open-in-new"></i> Open sitemap.xml
                    </a>
                    </div>
                  ) : (
                    <p>No XML file available</p>
                  )}
                </Form.Group>
             
              </div>
              <Button variant="success" type="submit">Submit</Button>
            </Form>
          </div>
        </div>
        <Footer />
         </div>
      )}
      </div>
    </div>
  );
};

export default Seoxmlsitemap;
